export enum DefinicjeParametrow {
  STRONA_KONTAKT = 'STRONA_KONTAKT',
  STRONA_MAPA_SERWISU = 'STRONA_MAPA_SERWISU',
  STRONA_POLITYKA_PRYWATNOSCI = 'STRONA_POLITYKA_PRYWATNOSCI',
  STRONA_DEKLARACJA_DOSTEPNOSCI = 'STRONA_DEKLARACJA_DOSTEPNOSCI',
  ADRES_INSTRUKCJA = 'ADRES_INSTRUKCJA',
  ADRES_INSTRUKCJA_ADMINISTRATORA = 'ADRES_INSTRUKCJA_ADMINISTRATORA',
}
